module.exports = __webpack_public_path__ + "img/11.6c2c99f0.jpg";